import React from 'react';
import { Tag } from '../Tag';

export const CheckRow = ({ item }) => (
    <div className="chk">
        <span className="chk-n">{item.name}</span>
        {item.status && <Tag tone={item.style}>{item.status}</Tag>}
        {item.note && <span className="chk-note">{item.note}</span>}
    </div>
);
